var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCakes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38B;}\n\t.st1{fill:#8A4C38;}\n\t.st2{fill:#AD5641;}\n\t.st3{fill:#662214;}\n\t.st4{fill:#8BC5ED;}\n\t.st5{fill:#F0C15E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.19,185.11c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.89,150.81,62.5,185.11,105.19,185.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.5,130.82c0,10.41-16.71,18.85-37.31,18.85c-20.61,0-37.31-8.44-37.31-18.85s16.7-18.84,37.31-18.84 C125.79,111.97,142.5,120.41,142.5,130.82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.65,130.96c0,13.2-20.35,23.89-45.46,23.89c-25.11,0-45.46-10.69-45.46-23.89 c0-13.19,20.35-23.89,45.46-23.89C130.3,107.08,150.65,117.77,150.65,130.96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.28,127.43c0,30.53-88.19,30.53-88.19,0v-27.13h88.19V127.43z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.65,97.05c0,13.19-20.35,23.89-45.46,23.89c-25.11,0-45.46-10.69-45.46-23.89s20.35-23.89,45.46-23.89 C130.3,73.16,150.65,83.86,150.65,97.05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128.93,100.29c-1.87,0-3.39-1.52-3.39-3.39l0,0V73.16c0-1.87,1.52-3.39,3.39-3.39s3.39,1.52,3.39,3.39V96.9 C132.33,98.77,130.81,100.29,128.93,100.29L128.93,100.29 M105.19,110.47c-1.87,0-3.39-1.52-3.39-3.39l0,0V83.33 c0-1.87,1.52-3.39,3.39-3.39c1.87,0,3.39,1.52,3.39,3.39v23.74C108.58,108.95,107.06,110.47,105.19,110.47L105.19,110.47  M81.45,100.29c-1.87,0-3.39-1.52-3.39-3.39l0,0V73.16c0-1.87,1.52-3.39,3.39-3.39c1.87,0,3.39,1.52,3.39,3.39V96.9 C84.84,98.77,83.32,100.29,81.45,100.29L81.45,100.29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M81.45,78.24c-3.6,0-6.43-1.65-7.57-4.4c-0.99-2.4-1.48-7.59,6.37-15.45c0.66-0.66,1.74-0.66,2.4,0 c7.86,7.86,7.37,13.05,6.37,15.45C87.88,76.6,85.05,78.24,81.45,78.24 M105.19,88.42c-3.6,0-6.43-1.65-7.57-4.41 c-0.99-2.39-1.48-7.59,6.37-15.45c0.66-0.66,1.74-0.66,2.4,0c7.86,7.86,7.36,13.05,6.37,15.45 C111.62,86.77,108.79,88.42,105.19,88.42 M128.93,78.24c-3.6,0-6.43-1.65-7.57-4.4c-0.99-2.4-1.49-7.59,6.37-15.45 c0.66-0.66,1.74-0.66,2.4,0c7.86,7.86,7.36,13.05,6.37,15.45C135.36,76.6,132.54,78.24,128.93,78.24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCakes);
export default __webpack_public_path__ + "static/media/Cakes.eef317509b4b36562b4aa664f0448d70.svg";
export { ForwardRef as ReactComponent };